export default "assets/images/stars-4-93ee591d.png";